/**
 * Validated email address value object
 */
export type Email = Readonly<string>;

/**
 * Creates a validated Email value object.
 *
 * @param raw - Raw email string
 * @returns Validated Email
 * @throws Error if email format is invalid
 */
export const createEmail = (raw: string): Email => {
  const trimmed = raw?.trim().toLowerCase();
  if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    throw new Error('Invalid email format');
  }
  return trimmed as Email;
};
